<template>
  <div id="app">
  <div class="section text-center" style="padding-top: 0px">
    <video autoplay muted loop id="video1-bg">
      <source src="times.mp4" type="video/mp4">
    </video>
  <b-navbar toggleable="lg" type="dark" variant="info" style="background-color: black !important; margin-bottom: 100px">
    <b-navbar-brand id="title" href="#">Adport</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">

      </b-navbar-nav>
    </b-collapse>
  </b-navbar>

  <vue-typed-js id="typed" :strings="['Decentralized', 'Programmatic', 'Place-Based']" :typeSpeed="80" :backSpeed="20" loop>
    <h1><span class="typing"></span></h1>
  </vue-typed-js>
    <h1 id="typed">DOOH Advertising</h1>
    <a class="btn btn-primary btn-lg" href="https://app.adport.it" role="button" style="margin-top:50px">Go to the Platform</a>
  </div>

  <div class="section" style="background-color:green">
    <h1 class="home-text">Decentralized</h1>
    <h2 class="home-text">Decentralized means everyone. And scalable</h2>
    <h5 class="home-text">The Adport Viewers Network is the first scalable digital signage network that everyone is free to join</h5>
  </div>

    <div class="section" style="background-color:grey">
      <h1 class="home-text">Programmatic</h1>
      <h2 class="home-text">Scheduled slots for precise marketing</h2>
      <h5 class="home-text">Advertisers are able to schedule a slot and know exactly when their media is going to be played</h5>
    </div>

    <div class="section" style="background-color:green">
      <h1 class="home-text">Place-Based</h1>
      <h2 class="home-text">Viewers can be everywhere</h2>
      <h5 class="home-text">Advertisers can take advantage of geo-localization data and reach their audience at the right place</h5>
    </div>

    <div class="section" style="background-color:grey">
      <h1 class="home-text">AI on the edge</h1>
      <h2 class="home-text">In-place data processing, thanks to AIoT</h2>
      <h5 class="home-text">The edge computing of the Adport Viewers Network is equipped with nano GPUs for real-time local data elaboration</h5>
    </div>

    <div class="section" style="background-color:green">
      <h1 class="home-text">Transparent reporting</h1>
      <h2 class="home-text">Thanks to the blockchain</h2>
      <h5 class="home-text">With AI combined with the blockchain technology, Adport is able to give truthful feedbacks to Advertisers about the impact of their media</h5>
    </div>

  </div>
</template>

<script>

export default {
  name: 'app',

}
</script>

<style scoped>

@font-face {
  font-family: gotham;
  src: url('./Gotham-Black.otf');
}

@font-face {
  font-family: gothambook;
  src: url('./GothamBook.ttf');
}

body {
  background-color: #00242d !important;
}

#video1-bg {
  z-index: -100;
  opacity: 0.3;
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
}

#title {
  font-family: gotham;
  text-transform: uppercase
}

.home-text  {
  font-family: gothambook;
  color: white;
  margin-left: 10%;
}

#join-central {
  margin-top: 10%;
}

.section {
  padding-top: 10%;  
  min-height: 100vh;
}

@media screen and (min-width: 800px) {
  #typed, span {
    font-size: 85px;
    font-family: gotham;
    color:white;
    justify-content: center;
  }
}

.typed-cursor {
  color: #52a0fb !important
}

#typed {
  font-family: gotham;
  color:white;
  justify-content: center;
}

</style>
